import type { ControlBridgeQueueItem } from '../deriveViewModel';
import type { RenderManifestField } from '../../../types/kryspaceRenderManifest';

export type ControlBridgeEntityDetailTarget =
  | {
      kind: 'item';
      itemId: string;
      invokingLabel: string;
      fallbackItem?: ControlBridgeQueueItem;
    }
  | {
      kind: 'artifact';
      artifactInstanceId: string;
      invokingLabel: string;
      fallbackLabel?: string;
    };

export function queueItemFallbackFields(item: ControlBridgeQueueItem): RenderManifestField[] {
  return [
    {
      key: 'priority',
      label: 'Priority',
      value: item.priority ?? null,
      affordance: 'plain',
      tier: 'core',
      readOnly: true,
    },
    {
      key: 'assigned',
      label: 'Assigned',
      value: item.assignedResourceLabel ?? item.assignedResourceRef ?? null,
      affordance: 'plain',
      tier: 'core',
      readOnly: true,
    },
    {
      key: 'waypoint',
      label: 'Waypoint',
      value: item.waypointRef ?? null,
      affordance: 'plain',
      tier: 'context',
      readOnly: true,
    },
  ];
}

export function queueItemFallbackTitle(item: ControlBridgeQueueItem): string {
  return item.title;
}

export function queueItemFallbackSubtitle(item: ControlBridgeQueueItem): string {
  return item.itemId;
}

export function queueItemFallbackState(item: ControlBridgeQueueItem): string | undefined {
  return item.statusPhrase;
}

export function normalizeEntityDetailFields(
  fields: Array<Partial<RenderManifestField> & { key: string; label: string }>
): RenderManifestField[] {
  return fields.map((field) => ({
    key: field.key,
    label: field.label,
    value: field.value ?? null,
    affordance: field.affordance ?? 'plain',
    tier: field.tier ?? 'core',
    readOnly: field.readOnly ?? true,
  }));
}
